import { render, staticRenderFns } from "./SpaceLinks.vue?vue&type=template&id=1ee9e8aa"
import script from "./SpaceLinks.vue?vue&type=script&lang=js"
export * from "./SpaceLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports